<template>
  <section class="mobile-home">
    <!-- 상단 배너 -->
    <div class="top-banner">
      <span class="top-banner-text">청주 레이원시티 홍보관 상담센터</span>
    </div>

    <!-- 홍보 이미지들 -->
    <template v-for="(image, index) in images" :key="index">
      <div class="image-wrapper">
        <img
          :src="image.src"
          :alt="`홍보 이미지 ${index + 1}`"
          loading="lazy"
        />
      </div>
      <!-- home2.jpg 다음에 유튜브 영상 삽입 -->
      <div v-if="image.name === 'home2'" class="video-wrapper">
        <iframe
          :src="`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&playlist=${youtubeId}&playsinline=1&controls=0&showinfo=0&rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </template>

    <!-- 마지막: 상담 신청 폼 -->
    <div class="contact-form-section">
      <div class="form-header">
        <h3 class="form-title">상담 신청</h3>
        <p class="form-desc">연락처를 남겨주시면 빠르게 연락드립니다</p>
      </div>
      <form @submit.prevent="submitForm" class="contact-form">
        <input
          type="text"
          v-model="form.name"
          placeholder="이름"
          required
          :disabled="isSubmitting"
        />
        <div class="phone-inputs">
          <input
            ref="hPhone1"
            type="tel"
            inputmode="numeric"
            v-model="form.phone1"
            placeholder="010"
            maxlength="3"
            required
            :disabled="isSubmitting"
            @input="onPhoneInput('phone1', 3, 'hPhone2')"
          />
          <span class="phone-dash">-</span>
          <input
            ref="hPhone2"
            type="tel"
            inputmode="numeric"
            v-model="form.phone2"
            placeholder="0000"
            maxlength="4"
            required
            :disabled="isSubmitting"
            @input="onPhoneInput('phone2', 4, 'hPhone3')"
          />
          <span class="phone-dash">-</span>
          <input
            ref="hPhone3"
            type="tel"
            inputmode="numeric"
            v-model="form.phone3"
            placeholder="0000"
            maxlength="4"
            required
            :disabled="isSubmitting"
            @input="onPhoneInput('phone3', 4, null)"
          />
        </div>
        <label class="checkbox-label">
          <input type="checkbox" v-model="form.agreePrivacy" required :disabled="isSubmitting" />
          <span class="checkmark"></span>
          <span>개인정보 수집 및 이용 동의</span>
        </label>
        <button type="submit" class="submit-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
        </button>
      </form>
    </div>

    <CommonFooter />
  </section>
</template>

<script>
import CommonFooter from '@/components/common/CommonFooter.vue'

export default {
  name: 'MobileHomeView',
  components: {
    CommonFooter
  },
  data() {
    return {
      youtubeId: 'yWVeR23uK6A',
      images: [],
      isSubmitting: false,
      form: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agreePrivacy: false
      }
    }
  },
  created() {
    this.loadImages()
  },
  methods: {
    loadImages() {
      try {
        const requireImages = require.context(
          '@/assets/mobile/',
          false,
          /^\.\/home\d+\.(jpg|jpeg|png|gif|webp)$/i
        )

        const sortedKeys = requireImages.keys().sort((a, b) => {
          const numA = parseInt(a.match(/\d+/)[0])
          const numB = parseInt(b.match(/\d+/)[0])
          return numA - numB
        })

        this.images = sortedKeys.map(key => ({
          src: requireImages(key),
          name: key.match(/\.\/(home\d+)/)[1]
        }))
      } catch (e) {
        console.warn('모바일 이미지 폴더가 없습니다.')
        this.images = []
      }
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.form[field] = this.form[field].replace(/[^0-9]/g, '')
      if (this.form[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.form.agreePrivacy) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        // Firebase 연동 시 주석 해제
        // const { saveConsultation } = await import('@/firebase/consultationService')
        // const result = await saveConsultation({
        //   name: this.form.name,
        //   phone: this.form.phone
        // }, 'mobile-form')

        // 임시: 성공 처리
        await new Promise(resolve => setTimeout(resolve, 1000))
        // 네이버 신청완료(lead) 전환 추적
        if (typeof window.naverLeadConversion === 'function') window.naverLeadConversion() // eslint-disable-line no-undef
        alert('등록이 완료되었습니다. 빠른 시간 내에 연락드리겠습니다.')
        this.form = { name: '', phone1: '010', phone2: '', phone3: '', agreePrivacy: false }
      } catch (error) {
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.mobile-home {
  width: 100%;
  padding-top: 60px; /* 헤더 높이만큼만 */
}

/* 상단 배너 */
.top-banner {
  width: 100%;
  background: var(--rayone-primary);
  padding: 14px 20px;
  text-align: center;
}

.top-banner-text {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
}

.image-wrapper {
  width: 100%;
  line-height: 0;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

/* 유튜브 영상 */
.video-wrapper {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 비율 */
  background: #000;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 상담 신청 폼 섹션 */
.contact-form-section {
  width: 100%;
  padding: 40px 24px 50px;
  background: linear-gradient(135deg, var(--rayone-primary) 0%, var(--rayone-primary-dark) 100%);
  position: relative;
}

.contact-form-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 5px solid transparent;
  background:
    linear-gradient(135deg, var(--rayone-primary) 0%, var(--rayone-primary-dark) 100%) padding-box,
    linear-gradient(
      var(--gold-angle, 0deg),
      #D4AF37,
      #FFF8DC,
      #D4AF37,
      #B8860B,
      #FFD700,
      #D4AF37
    ) border-box;
  animation: rotate-gold 3s linear infinite;
  pointer-events: none;
  z-index: 0;
  box-shadow:
    0 0 15px rgba(212, 175, 55, 0.4),
    0 0 30px rgba(212, 175, 55, 0.2),
    inset 0 0 15px rgba(212, 175, 55, 0.1);
}

.contact-form-section > * {
  position: relative;
  z-index: 1;
}

@property --gold-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes rotate-gold {
  to {
    --gold-angle: 360deg;
  }
}

.form-header {
  text-align: center;
  margin-bottom: 24px;
}

.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.form-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-form input[type="text"],
.contact-form input[type="tel"] {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-family: var(--font-pretendard);
  background: rgba(255, 255, 255, 0.95);
  color: #333;
}

.contact-form input::placeholder {
  color: #999;
}

/* 전화번호 3칸 */
.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-dash {
  color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
  flex-shrink: 0;
}

.contact-form input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  cursor: pointer;
  padding: 8px 0;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.checkbox-label input:checked + .checkmark {
  background: #fff;
  border-color: #fff;
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid var(--rayone-primary);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: var(--rayone-primary);
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  font-family: var(--font-pretendard);
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 8px;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.9;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
